import {
  Button,
  Drawer,
  Form,
  Space,
  Input,
  message,
  Row,
  Col,
  Select,
  DatePicker,
  Modal,
} from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { AiOutlineCheck, AiOutlineClose } from "react-icons/ai";
import { MdCheck } from "react-icons/md";
import fetchDataTrace from "../../../services/fetchDataTrace";
import postDataTrace from "../../../services/postDataTrace";

const { Option } = Select;

export default function BookingPanel({
  setVisible,
  isVisible,
  selected,
  refetch,
}: any) {
  const [search, setSearch] = useState("");
  const [bookings, setBookings] = useState<any>([]);
  const [slotModal, setSlotModal] = useState(false);
  const [selectedTime, setSelectedTime] = useState<any>(null);
  const [availability, setAvailability] = useState<any>(null);
  const [isOtherModel, setIsOtherModel] = useState<boolean>(false);
  const [servType, setServType] = useState("Service");
  const [date, setDate] = useState(null);
  const [centers, setCenters] = useState<any>(null);
  const [models, setModels] = useState<any>([]);

  const handleFetchCustomerBooking = async () => {
    const uri = `bookings/customers/${selected?._id}`;
    const response = await fetchDataTrace({ uri });
    setBookings(response?.payload);
  };

  const types = [
    { id: 1, name: "Service" },
    { id: 2, name: "Repair" },
  ];

  const year = new Date().getFullYear() + 1;

  const years: any = [];

  for (let i = 1998; i < year; i++) {
    years.push({ year: i });
  }

  const [form] = Form.useForm();

  const onSubmit = async () => {
    const { vehicle, center, model, mileage, year } =
      await form.validateFields();
    let formated = vehicle.replace(/\s/g, "");
    const data = {
      date: selectedTime?.starttime,
      time: selectedTime?.starttime,
      description: servType,
      slottime: selectedTime?._id,
      site: center,
      title: `${formated}`,
      vehicle: formated,
      mileage: mileage,
      model_year: year,
      model: model,
      status: "Unconfirmed",
      contact: "",
      is_confirmed: false,
      customer_id: selected?._id,
      customer_name: selected?.name,
      customer_code: selected?.account,
      customer_mobile: selected?.mobile,
    };


    const uri = `bookings`;

    const response = await postDataTrace(data, uri);

    if (response.success === false) {
      message.error(response.message);
      return;
    }

    message.success("Booking added successfully");
    await refetch();
    setVisible(false);
  };

  const onChangeDate = async (event: any, selectedDate: any) => {
    const currentDate = event;
    const uri = `slotdates/check?date=${currentDate}`;
    setDate(currentDate);
    setSelectedTime(null);
    const response = await fetchDataTrace({ uri });
    setAvailability(response?.payload);
  };

  const handleFetchSites = async () => {
    const uri = "sites";
    const response = await await fetchDataTrace({ uri });
    setCenters(response?.payload);
  };

  const handleFetchModels = async () => {
    const uri = `quotations/models/all`;
    const response = await fetchDataTrace({ uri });
    setModels(response);
  };

  const clearForm = async () => {
    form.resetFields();
    setSelectedTime(null);
    setDate(null);
  };

  const handleModelChange = (e: any) => {
    if (e === "OTHER MODEL") {
      setIsOtherModel(true);
    } else {
      setIsOtherModel(false);
    }
  };

  const centerOptions = centers?.map((center: any, index: number) => (
    <Option value={center?._id} key={index}>
      {center?.name}
    </Option>
  ));

  const yearOptions = years?.map((item: any, index: number) => (
    <Option value={item?.year} key={index}>
      {item?.year}
    </Option>
  ));

  const modelOptions = models?.map((item: any, index: number) => (
    <Option value={item?.name} key={index}>
      {item?.name}
    </Option>
  ));

  useEffect(() => {
    handleFetchCustomerBooking();
    handleFetchSites();
    handleFetchModels();
    form.resetFields();
  }, [selected]);

  const handleClearSearch = () => {
    setSearch("");
    form.resetFields();
  };

  const handleHideModal = () => {
    setSlotModal(false);
  };

  return (
    <Drawer
      title={`${selected?.name} : Bookings`}
      placement={"right"}
      width={800}
      onClose={() => setVisible(!isVisible)}
      visible={isVisible}
      closable={false}
      extra={
        <Space className="flex justify-center items-center">
          <Button
            type="default"
            color="#E50000"
            onClick={() => setVisible(!isVisible)}
            danger
          >
            <AiOutlineClose />
          </Button>
        </Space>
      }
    >
      <Form
        id="createBooking"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout={"vertical"}
      >
        <Row gutter={[16, 0]}>
          {types.map((type: any) => (
            <Col xs={{ span: 24 }} lg={{ span: 12 }}>
              <button
                type="button"
                className="flex flex-row  items-center mb-4 border w-full"
                onClick={() => setServType(type.name)}
              >
                {servType === type.name ? (
                  <div className="h-8 w-8 border-r flex justify-center items-center bg-green-100">
                    <AiOutlineCheck />
                  </div>
                ) : (
                  <div className="h-8 w-8 border-r flex justify-center items-center">
                    <AiOutlineCheck color="#FFFFFF" />
                  </div>
                )}
                <div className="ml-4"></div>
                {type.name}
              </button>
            </Col>
          ))}
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="customer_name"
              label="Customer Name"
              initialValue={selected?.name}
              rules={[
                {
                  required: true,
                  message: "Please select customer name",
                },
              ]}
            >
              <Input placeholder="Customer Name" />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="customer_mobile"
              label="Customer Mobile"
              initialValue={selected?.mobile}
              rules={[
                {
                  required: true,
                  message: "Please select customer mobile",
                },
              ]}
            >
              <Input placeholder="Customer Mobile" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="vehicle"
              label="Vehicle Registration"
              rules={[
                {
                  required: true,
                  message: "Please enter vehicle registration",
                },
              ]}
            >
              <Input placeholder="Vehicle Registration" />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="model"
              label="Model Name"
              rules={[
                {
                  required: true,
                  message: "Please select model",
                },
              ]}
            >
              <Select
                placeholder="Model Name"
                onChange={(e) => handleModelChange(e)}
              >
                {modelOptions}
                <Option value={"OTHER MODEL"}>OTHER MODEL</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 0]}>
          {isOtherModel ? (
            <Col xs={{ span: 24 }} lg={{ span: 24 }}>
              <Form.Item
                name="othermodel"
                label="Specify Model"
                rules={[
                  {
                    required: true,
                    message: "Please enter Model name",
                  },
                ]}
              >
                <Input placeholder="Specify Model Name" />
              </Form.Item>
            </Col>
          ) : null}
        </Row>

        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="year"
              label="Model Year"
              rules={[
                {
                  required: true,
                  message: "Please enter year",
                },
              ]}
            >
              <Select placeholder="Model Year">{yearOptions}</Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="mileage"
              label="Mileage"
              rules={[
                {
                  required: true,
                  message: "Please enter Mileage",
                },
              ]}
            >
              <Input placeholder="Mileage" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="center"
              label="Center"
              rules={[
                {
                  required: true,
                  message: "Please enter center",
                },
              ]}
            >
              <Select placeholder="Center">{centerOptions}</Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="date"
              label="Date"
              rules={[
                {
                  required: true,
                  message: "Please select date",
                },
              ]}
            >
              <DatePicker
                format={"Do MMM, YYYY"}
                onChange={onChangeDate}
                className="w-full"
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 0]}>
          {date ? (
            <Col xs={{ span: 24 }} lg={{ span: 12 }}>
              <Form.Item
                name="time"
                label="Time"
                rules={[
                  {
                    required: false,
                    message: "Please select time",
                  },
                ]}
              >
                {selectedTime ? (
                  <div
                    className="border p-1 w-full px-2 text-black"
                    onClick={() => setSlotModal(true)}
                  >
                    {moment(selectedTime?.starttime).format("HH:mm")}
                    {" - "}
                    {moment(selectedTime?.endtime).format("HH:mm")}
                  </div>
                ) : (
                  <div
                    onClick={() => setSlotModal(true)}
                    className="border p-1 w-full px-2 text-gray-400 hover:cursor-pointer"
                  >
                    Time
                  </div>
                )}
              </Form.Item>
            </Col>
          ) : null}
        </Row>
        <Form.Item>
          <Button danger type="primary" htmlType="submit">
            Submit
          </Button>
          <Button htmlType="button" className="mx-2" onClick={clearForm}>
            Reset
          </Button>
          <Button
            htmlType="button"
            className="mx-2"
            onClick={() => setVisible(false)}
          >
            Close
          </Button>
        </Form.Item>
      </Form>

      <Modal
        visible={slotModal}
        title={`Booking Slots :  ${moment(date).format("Do MMM, YYYY")}`}
        onCancel={handleHideModal}
        footer={false}
      >
        {availability?.data[0]?.slottimes?.map((slot: any, index: number) => (
          <div
            className="flex justify-between items-center border-t py-2"
            key={index}
            onClick={() => {
              setSelectedTime(slot);
              setSlotModal(false);
            }}
          >
            <div className="flex">
              <div className="mr-2">{index + 1}.</div>
              <div className="flex ml-4">
                <span style={{ color: "#323232" }}>
                  {moment(slot?.starttime).format("HH:mm")}
                </span>
                <span className="mx-4">-</span>
                <span style={{ color: "#323232" }}>
                  {moment(slot?.endtime).format("HH:mm")}
                </span>
              </div>
            </div>
            <div className="flex justify-center items-center ml-4">
              <div className="bg-gray-200 px-16 py-1 mr-4">
                <span className="text-red-600">
                  {10 - slot?.bookings?.length}
                </span>
                <span className="mx-2">Slots left</span>
              </div>
              <div className="h-8 w-8 border flex justify-center items-center">
                {selectedTime?._id === slot?._id ? (
                  <MdCheck size={15} color="green" />
                ) : null}
              </div>
            </div>
          </div>
        ))}
      </Modal>
    </Drawer>
  );
}
